var _g, _path, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScadaLinkArrowDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "200px",
    viewBox: "0 0 0.22 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#f9fafb",
    strokeWidth: 0.01,
    strokeMiterlimit: 22.9256
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.06,
    y1: 0,
    x2: 0.06,
    y2: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.06 1.24c0.07,0 0.12,-0.05 0.12,-0.12 0,-0.07 -0.05,-0.13 -0.12,-0.13"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9fafb",
    strokeWidth: 0.01,
    d: "M0.05 2.9l0 -1.66 0.01 0 0 1.66 -0.01 0zm0.06 -0.0l-0.05 0.1 -0.06 -0.1 0.11 0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f9fafb",
    stroke: "#f9fafb",
    strokeWidth: 0.01
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.06,
    cy: 0.99,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.06,
    cy: 1.24,
    r: 0.03
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScadaLinkArrowDark);
export default __webpack_public_path__ + "static/media/scada_link_arrow_dark.74985497.svg";
export { ForwardRef as ReactComponent };